function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Succes Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "All-good"
}, React.createElement("g", {
  id: "round"
}, React.createElement("g", {
  id: "\\u25A0-BG",
  fill: "#8BCD42"
}, React.createElement("circle", {
  id: "Oval",
  cx: 15,
  cy: 15,
  r: 15
})), React.createElement("g", {
  id: "Foundation-/-icons-/-check",
  transform: "translate(3.181818, 3.181818)",
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M18.71,7.21 C18.5222334,7.02068734 18.2666375,6.91420167 18,6.91420167 C17.7333625,6.91420167 17.4777666,7.02068734 17.29,7.21 L9.84,14.67 L6.70999999,11.53 C6.44740979,11.2763414 6.06944119,11.1820414 5.71847132,11.282622 C5.36750144,11.3832025 5.09685097,11.6633829 5.00847131,12.017622 C4.92009165,12.371861 5.02740978,12.7463414 5.28999999,13 L9.13,16.84 C9.3177666,17.0293127 9.57336246,17.1357983 9.84,17.1357983 C10.1066375,17.1357983 10.3622334,17.0293127 10.55,16.84 L18.71,8.68 C18.9152112,8.49068441 19.0319329,8.22419889 19.0319329,7.945 C19.0319329,7.66580111 18.9152112,7.39931558 18.71,7.21 Z",
  id: "SuccesIcon"
})))));

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.ee327a06.svg";
export { ForwardRef as ReactComponent };